const commonUrls = [
    ['Github', 'https://github.com', '远程代码托管平台'],
    ['Gitee', 'https://gitee.com', '远程代码托管平台'],
    ['GeoGebra', 'https://geogebra.org', '数学工具'],
    ['CSDN', 'https://csdn.net', 'Markdown 笔记'],
    ['简书', 'https://jianshu.com', 'Markdown 笔记'],
    ['Draw', 'https://draw.io', 'Draw.io 画图工具'],
    ['百度脑图', 'https://naotu.baidu.com', '思维导图'],
    ['百度', 'https://baidu.com', '百度搜索引擎'],
    ['bilibili', 'https://bilibili.com', 'B 站'],
];

const codeUrls = [
    ['Github', 'https://github.com', '远程代码托管平台'],
    ['Cloudflare', 'https://cloudflare.com', 'Cloudflare 部署'],
    ['CodePen', 'https://codepen.io', 'CodePen 设计'],
    ['Gitee', 'https://gitee.com', '远程代码托管平台'],
];

const noteUrls = [
    ['CSDN', 'https://csdn.net', 'Markdown 笔记'],
    ['简书', 'https://jianshu.com', 'Markdown 笔记'],
    ['Draw', 'https://draw.io', 'Draw.io 画图工具'],
    ['百度脑图', 'https://naotu.baidu.com', '思维导图'],
]

const obj = {
    '/': commonUrls,
    '/code': codeUrls,
    '/note': noteUrls,
}

export default obj;